import {baseActions, baseMutations} from '@/store/baseCollections';
const {subscribeCollections} = baseActions;
const {updateCollection} = baseMutations;

const state = {
  collectionNames: ['features'],
  features: [],
};

const mutations = {
  updateCollection,
};

const actions = {
  subscribeCollections,
};

export default {
  namespaced: true,
  state: () => state,
  mutations,
  actions,
};
